window.console || (window.console = {
	log: function(){}
});
var FUNCTIONS = window.FUNCTIONS || null;
var cssua = window.cssua || null;

(function($){
	const htmlHasClass = (_class) => {
		return $('html').hasClass(_class);
	};
	const siteName = '';
	const a = 'is-active';
	const v = 'is-visible';
	const slideSpeed = '400';

	FUNCTIONS = {
		va: {
			pathname: location.pathname,
			isMobile: htmlHasClass('ua-mobile'),
			device: {
				desktop: 1024,
				sp: 768
			},
			window: {
				width: $(window).width(),
				height: $(window).height()
			}
		},
		localDecision(){
			var regExp = new RegExp(`(test\\.${siteName}\\.connecty\\.co\\.jp|copre\\.jp|localhost|192\\.168\\.)`, 'g');
			return regExp.test(location.hostname);
		},
		localLoading(){
			let _this = this;
			// ローカル環境ならincludeをAjaxで読み込む
			let key = 'inc_';
			let ajaxArray = [];
			let ajaxArrayList = [];
			let includeClass = document.querySelectorAll(`[class*="${key}"]`);
			let includeClassLen = includeClass.length;

			for (let i=0; i < includeClassLen; i++) {
				var path = includeClass[i].innerHTML.split(' ')[1];
				ajaxArray.push(path);
			}
			var ajaxLen = ajaxArray.length;

			if (ajaxLen > 0) {
				for (let i=0; i < ajaxLen; i++) {
					ajaxArrayList[i] = $.ajax({
						type: 'GET',
						url: ajaxArray[i] + '.html',
						dataType: 'html',
						timeout: 5000
					});
				}
				$.when.apply($, ajaxArrayList).done((...args) => {
					let regExp = new RegExp(key);

					if (args[1] === 'success') { // includeが1個だけの場合
						let position = $(args[0]).filter(':first').attr('class').split(' ');
						for (let j = 0; j < position.length; j++) {
							if (position[j].match(regExp)) {
								position = position[j];
								break;
							}
						}
						$('.' + position).html(args[0]).children().unwrap();

						console.log('Succeeded to read the include file!:', position);
					} else {
						for (let i=0; i < args.length; i++) {
							let result = args[i];
							let position = $(result[0]).filter(':first').attr('class').split(' ');

							for (let j=0; j < position.length; j++) {
								if (position[j].match(regExp)) {
									position = position[j];
									break;
								}
							}
							$('.' + position).html(result[0]).children().unwrap();

							console.log('Succeeded to read the include file!:', position);
						}
					}
					_this.loadDelayScript();
				});
			} else {
				_this.loadDelayScript();
			}
		},
		catchAjaxError(_errorThrown){
			if(window.ga) {
				window.ga('send', 'event', 'ajaxError', location.href, _errorThrown, 0, true);
			}
		},
		modal(){
			$('.mod-modal').on('click', (e) => {
				let HTML = '<div class="mod-modal-overlay">';
				HTML +=
					'<div class="mod-modal-closeArea"></div>'+
					'<span class="mod-modal-closeBtn"><span></span></span>' +
					`${$(e.currentTarget).find('img').prop('outerHTML')}</div>`;
				$('body').append(HTML);
				const $overlay = $('.mod-modal-overlay');
				$overlay.addClass(a);
				setTimeout(() => {
					$overlay.addClass(v);
					$('.mod-modal-closeArea, .mod-modal-closeBtn').on('click', () => {
						$overlay.removeClass(v);
						setTimeout(() => {
							$overlay.removeClass(a);
							$overlay.remove();
						}, 400);
					});
				});
			});
		},
		lazyload(){
			if($(".js-lazy-img").length) {
				$(".js-lazy-img").lazyload();
			}
		},
		loadDelayScript(){
			var _this = this;
			_this.modal();
			_this.lazyload();
		}
	};

	$(() => FUNCTIONS.localDecision() ? FUNCTIONS.localLoading() : FUNCTIONS.loadDelayScript());
})(window.jQuery);
